import { Paper } from '@material-ui/core';
import { ObjectType } from '../../../../../../../../types/objectType';

export const CustomNoElevationPaper = (props: ObjectType) => (
  <Paper elevation={0} {...props} style={{ background: '#e6e6e6' }}
  />);
